<template>

  <svg
    t="1631089301762"
    class="icon"
    viewBox="0 0 1024 1024"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    p-id="6233"
    width="64"
    height="64"
  ><path d="M857.856 875.648H170.752c-55.552 0-100.736-46.08-100.736-102.656V207.424c0-56.576 45.184-102.656 100.736-102.656h687.104c55.552 0 100.736 46.08 100.736 102.656v565.504c0.064 56.64-45.184 102.72-100.736 102.72z m-687.104-706.88c-20.224 0-36.736 17.344-36.736 38.656v565.504c0 21.312 16.512 38.656 36.736 38.656h687.104c20.224 0 36.736-17.344 36.736-38.656V207.424c0-21.312-16.512-38.656-36.736-38.656H170.752z" p-id="6234" /><path d="M397.76 374.464c0-35.2 24.96-49.6 55.424-32l200.32 115.712c30.528 17.6 30.528 46.4 0 64l-200.32 115.712c-30.464 17.6-55.424 3.264-55.424-32V374.464z" p-id="6235" /></svg>


</template>

<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'JtIconMedia',
} as DefineComponent
</script>